class BarcodeScanner {
  initialize = () => {
    document.addEventListener('keypress', this.keyup)
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
    }
    this.timeoutHandler = setTimeout(() => {
      this.inputString = ''
    }, 0)
  }

  close = () => {
    document.removeEventListener('keypress', this.keyup)
  }

  timeoutHandler = 0;
  inputString = '';

  keyup = (e) => {
    if ((e.target.tagName !== 'BODY')) return false;
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      if (e.keyCode !== 13) {
        this.inputString += e.key;
      }
    }

    this.timeoutHandler = setTimeout(() => {
      if (this.inputString.length >= 5 && e.keyCode === 13) {
        this.inputString = this.inputString.replace('\\000026', '');
        let event = new CustomEvent('onbarcodescanned', {detail : this.inputString})
        document.dispatchEvent(event);
      }
      this.inputString = ''
    }, 500)
  }
}

export default new BarcodeScanner();